import { P2 } from '~/src/geometry/point';
import { V2 } from '~/src/geometry/vector';
import * as Vec from '~/src/geometry/vector';
import * as Fig from '~/src/figure/Piece';

import { pieceBB } from '~/src/figure';

import State, { _project, Piece, ipiece, pctrd, ppan, pzoom, pangle } from '../State';
import { comp, Fn } from '~/src/base/Function';
import { Optic, set } from '~/src/base/Optic';


export interface Center {
	tag : 'Center';
	all?: boolean;
}

export const center : Center =
	{ tag : 'Center' };

export const centerAll : Center =
	{ tag : 'Center' , all : true };

interface IPiece {
	idx : number;
	pce : Fig.Piece;
}

export const exeCenter = ( state : State , { all } : Center ) : State => {
	const { w , h } = state.size;
	const project = _project( 0 );

	if ( w <= 0 || h <= 0 ) return state;

	return ( state.figure.Pieces
		.map( ( pce : Fig.Piece , idx : number ) => ( { pce , idx } ) as IPiece )
		.filter( ( { idx } : IPiece ) : boolean => {
			return all || String( idx ) === state.active;
		} )
		.map( ( { pce , idx } : IPiece ) => {
			const piece : Optic< State , Piece > = ipiece( String( idx ) );

			const [ min , max ] : [ P2 , P2 ] = pieceBB( pce ).map( project ) as [ P2 , P2 ];
			const [ fgw , fgh ] : P2 = Vec.sub( max )( min );

			const margin : number = 50;
			const factor : number = Math.min( ( w - 2 * margin ) / Math.abs( fgw ) , ( h - 2 * margin ) / Math.abs( fgh ) );

			const newZoom : number = factor;

			const sizeFig : V2 = [ fgw , fgh ];
			const sizeSvg : V2 = [ w , h ];

			const cptFig : V2 = Vec.add( min as V2 )( Vec.scale( 0.5 )( sizeFig ) );
			const cptSvg : V2 = Vec.scale( 1 / newZoom )( Vec.scale( 0.25 )( sizeSvg ) );

			const newPan : V2 = Vec.add( cptSvg )( Vec.sub( cptSvg )( cptFig ) );

			return comp(
				set( comp( piece , pctrd ) )( true ),
				set( comp( piece , ppan ) )( newPan ),
				set( comp( piece , pzoom ) )( newZoom ),
				set( comp( piece , pangle ) )( 0 )
			);
		} )
		.reduce( ( mod : Fn< State , State > , cur : Fn< State , State > ) =>
			comp( mod , cur ) , ( s : State ) => s
		)( state ) as State);
};
